// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2DyhK","options":"AnswerScale_options__3PG6t","selected":"AnswerScale_selected__3D7Rr"};